export type PossibleScriptNames =
    | 'app'
    | 'initFileUserNotificationForm'
    | 'tps'
    | 'addFile'
    | 'multipleSelectScripts'
    | 'documentWithRecipientsCheckbox'
    | 'viewFile'
    | 'resetAvailableClients';

window.ScriptRegistry = (function () {
    const loadedScripts: Partial<Record<PossibleScriptNames, boolean>> = {};
    function loadScript(name: PossibleScriptNames) {
        return new Promise<void>(resolve => {
            if (loadedScripts[name]) {
                resolve();
            } else {
                document.addEventListener(name + '-loaded', () => resolve());
            }
        });
    }

    const knownScripts: Record<PossibleScriptNames, PossibleScriptNames> = {
        app: 'app',
        initFileUserNotificationForm: 'initFileUserNotificationForm',
        tps: 'tps',
        addFile: 'addFile',
        multipleSelectScripts: 'multipleSelectScripts',
        documentWithRecipientsCheckbox: 'documentWithRecipientsCheckbox',
        viewFile: 'viewFile',
        resetAvailableClients: 'resetAvailableClients',
    };

    return {
        knownScripts,
        register: function (name: PossibleScriptNames) {
            loadedScripts[name] = true;
            const event = new Event(name + '-loaded');
            document.dispatchEvent(event);
        },
        waitFor: function (scripts: PossibleScriptNames[], callback: () => void) {
            Promise.all(scripts.map(loadScript)).then(callback);
        },
    };
})();
